import React from 'react';
import PropTypes from 'prop-types';

const HeaderBanner = ({image, title, content, children}) => {
    const style = {
        backgroundImage: `url(${image})`
    }
    return (
        <div className="header-banner" style={style}>
            <div className="content-container jumbotron">
                {title && <h1>{title}</h1>}
                {content && <p>{content}</p>}
            </div>
            {children}
        </div>
    )
}

HeaderBanner.propTypes = {
    image: PropTypes.string,
    title: PropTypes.string,
    content: PropTypes.string,
    children: PropTypes.node
}

export default React.memo(HeaderBanner);
